/* ============
 * Actions for the requirements module
 * ============
 *
 * The actions that are available on the
 * requirements module.
 */
import axios from 'axios'

export default {
  checkIfPolicyHasPending ({ dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'requirement/all?policy=' + item.numeroPoliza + '&state=PENDIENTE')
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  filterPolicyRequirements ({ dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'requirement/all', { params: item })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getAllRequirementsPerPolicy ({ dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'requirement/all?policy=' + item.numeroPoliza)
          .then(res => {
            let tempData = res.data.data.filter(
              (item) => item.state !== 'RECHAZADO'
            );
            res.data.data = tempData;
            resolve(res);
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  sendCodeValidation ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/life/requirements/code-deliveries/' + item.numeroDocumento + '/' + item.numeroPoliza + '/' + item.metodoEnvio)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  validateCodeValidation ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(apiV2 + 'lines/life/requirements/code-validations/' + item.numeroDocumento + '/' + item.clave)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  // Delegado en la sesión de CR Auth (user/ensureSession); nunca rechaza, igual que antes
  checkJWT ({ dispatch }) {
    return dispatch('user/checkJWT', null, { root: true })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/requirements/actions.js